module.exports = __webpack_public_path__ + "static/media/195.a5b929b2.jpg";